// Square Payment Configuration - uses environment variables
export const SQUARE_CONFIG = {
  applicationId: process.env.REACT_APP_SQUARE_APPLICATION_ID,
  locationId: process.env.REACT_APP_SQUARE_LOCATION_ID,
  environment: process.env.REACT_APP_SQUARE_ENVIRONMENT || 'sandbox',
};

// Square script URLs
export const SQUARE_SCRIPT_URLS = {
  sandbox: 'https://sandbox-js.squareup.com/v2/paymentform',
  production: 'https://js.squareup.com/v2/paymentform'
};

// Test card numbers for sandbox testing
export const TEST_CARDS = {
  visa: '4111 1111 1111 1111',
  mastercard: '5555 5555 5555 4444',
  amex: '3782 822463 10005',
  discover: '6011 1111 1111 1117',
  declined: '4000 0000 0000 0002',
  insufficientFunds: '4000 0000 0000 9995',
  invalid: '4000 0000 0000 0127'
};

// Square payment form styles - removed due to SDK compatibility issues
// Use default Square styling instead
export const SQUARE_FORM_STYLES = null;

export default SQUARE_CONFIG;
